import BaseVue from '@/base/BaseVue';

export default class Index extends BaseVue {

}
